<template>
  <b-form @submit.prevent="submitForm">
    <div v-if="isLoading" class="py-3 text-center text-secondary">
      {{ $t("loadingData") }}
    </div>

    <template v-else-if="selectedSubscriptionPlan">
      <div v-if="settingType === SettingType.Quota">
        <template v-if="selectedSubscriptionPlan && selectedSubscriptionPlan.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL">
          <b-form-group>
            <template v-slot:label>
              {{ $t("maxParticipantPool") }}
            </template>
            <b-form-input v-model="maxParticipantPool" type="number" min="1" required />
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group>
            <template v-slot:label>
              <!-- numberOfConcurrentMeetings:số cuộc họp đồng thời -->
              Số CH đồng thời
            </template>
            <b-form-input v-model="numberOfConcurrentMeetings" type="number" min="1" required />
          </b-form-group>
          <b-form-group>
            <template v-slot:label>
              {{ $t("meetingConcurrentParticipantsLimit") }}
            </template>
            <b-form-input v-model="meetingConcurrentParticipantsLimit" type="number" min="1" required />
          </b-form-group>
        </template>
      </div>

      <!-- Storage configuration panel -->
      <b-form-group v-if="settingType === SettingType.Storage">
        <!-- <template v-slot:label>
          {{ $t("storageCapacity") }}
        </template> -->
        <div class="storage-info-box">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-secondary small">{{ $t("type") }}</span>
            <span class="">{{ typeSubscription }}</span>
          </div>
          <div v-if="isConcurrentMeetingStorageType" class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-secondary small">Số CH đồng thời</span>
            <span class="">{{ numberOfConcurrentMeetings }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-secondary small">{{ $t("capacitySubscriptions") }}</span>
            <span class="">{{ storageSubscription }} GB</span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-secondary small">{{ $t("currentExtraCapacity") }}</span>
            <span class="">{{ currentExtraStorage }} GB</span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-secondary small">{{ $t("purchaseExtraCapacity") }}</span>
            <div style="width: 120px;">
              <b-input-group size="sm" append="GB">
                <b-form-input v-model="extraStorageToBuy" type="number" min="0" max="100" required class=" text-center" />
              </b-input-group>
            </div>
          </div>
          <hr class="my-2 border-light-gray" />
          <!-- Tổng dung lượng sau khi mua = Dung lượng gói cước * số cuộc họp đồng thời (nếu có) + Dung lượng bổ sung hiện tại + Mua thêm dung lượng -->
          <div class="d-flex justify-content-between align-items-center text-success mt-2">
            <span class="">{{ $t("totalCapacityAfterPurchase") }}</span>
            <span class="h6 mb-0 ">{{ totalStorageAfterPurchase }} GB</span>
          </div>
        </div>
      </b-form-group>

      <!-- AI quota configuration panel -->
      <b-form-group v-if="settingType === SettingType.AI && checkCustomerHasAIQuota">
        <!-- <template v-slot:label>
          {{ $t("ai_quota") }}
        </template> -->
        <div class="storage-info-box">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-secondary small">{{ $t("type") }}</span>
            <span class=" text-primary">
              {{ aiQuotaTypeLabel }}
            </span>
          </div>
          <div v-if="!isAiQuotaUnlimited">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-secondary small">{{ $t("duration") }}</span>
              <span class="">{{ aiQuotaSubscription }} {{ $t("minutesCapital") }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-secondary small">{{ $t("currentExtraAiMinutes") }}</span>
              <span class="">{{ currentExtraAiMinutes }} {{ $t("minutesCapital") }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary small">
                {{ $t("purchaseExtraAiMinutes") }}
              </span>
              <div style="width: 120px;">
                <b-input-group size="sm" :append="$t('minutesCapital')">
                  <b-form-input v-model="aiMinutesToBuy" type="number" min="1" required class=" text-center" />
                </b-input-group>
              </div>
            </div>
            <hr class="my-2 border-light-gray" />
            <!-- Tổng thời lượng AI sau khi mua = Thời lượng gói cước + Thời lượng bổ sung hiện tại + Mua thêm thời lượng -->
            <div class="d-flex justify-content-between align-items-center text-success mt-2">
              <span class="">
                {{ $t("totalAiDurationAfterPurchase") }}
              </span>
              <span class="h6 mb-0 ">
                {{ Number(aiQuotaSubscription) + Number(currentExtraAiMinutes) + Number(aiMinutesToBuy) }} {{ $t("minutesCapital") }}
              </span>
            </div>
          </div>
        </div>
      </b-form-group>

      <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>
      <div v-if="!(settingType === SettingType.AI && isAiQuotaUnlimited)" class="text-right mt-4">
        <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
          $t("cancel") }}</b-button>
        <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("update") }}</b-button>
      </div>
    </template>
  </b-form>
</template>


<style lang="scss" scoped>
.btn-custom {
  background-color: #e0e0e0 !important;
  color: #000000 !important;
  font-size: 16px !important;
  border: 1px solid #ced4da !important;
}

.btn-custom:hover {
  background-color: #d5d5d5 !important;
}

.storage-info-box {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 1.25rem;
}

.border-light-gray {
  border-top: 1px solid #dee2e6;
}
</style>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import _ from "lodash";
import moment, { Moment, MomentInput } from "moment";
import BaseComponent from "@/components/BaseComponent";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import * as customerService from "@/service/customerService";
import BigNumber from "bignumber.js";
import { SubscriptionUnitTime } from "@/views/enums/unitTime";
import { getStorageTypeLabel, StorageType } from '@/views/enums/storageType';
import * as util from "@/service/util";
import { AiQuotaType } from '../../../views/enums/aiQuotaType';
import { SettingType } from '@/views/enums/settingType';
import { ManagementType } from '@/views/enums/subscriptionAction';

@Component
export default class SettingSubscriptionModal extends BaseComponent {
  SettingType = SettingType;
  ManagementType = ManagementType;
  datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  @Prop({ required: true }) customerDetail;
  @Prop({ required: true }) customerSubscription;
  @Prop({ default: 0 }) meetingConcurrentParticipantsLimit_s;
  @Prop({ default: 0 }) numberOfConcurrentMeetings_s;
  @Prop({ default: 0 }) maxParticipantPool_s;
  @Prop({ default: false }) hasAiFeature;
  @Prop({ default: SettingType.Quota }) settingType!: SettingType;
  @Emit("submitted") __submitted() { }

  meetingConcurrentParticipantsLimit = 0;
  numberOfConcurrentMeetings = 0;
  maxParticipantPool = 0;
  isLoading = true;
  subscriptionPlans = [];
  subscriptionPlanId: number = null;
  startTime: string = null;
  formErrorMsg = "";
  isSubmitting = false;
  extraStorageToBuy: number = 0;
  activeSubscriptionPlan = null;
  aiMinutesToBuy: number = 0;

  mounted() {
    this.meetingConcurrentParticipantsLimit = +(this.meetingConcurrentParticipantsLimit_s);
    this.numberOfConcurrentMeetings = +(this.numberOfConcurrentMeetings_s);
    this.maxParticipantPool = +(this.maxParticipantPool_s);
    this.extraStorageToBuy = 0;
    this.aiMinutesToBuy = 0;
    this.startTime = moment().format("YYYY-MM-DD");
    this.fetchSubscriptionPlans();
  }


  durationLimits() {
    switch (this.selectedSubscriptionPlan.unitTime) {
      case SubscriptionUnitTime.months:
        return { min: 1, max: 36 };
      case SubscriptionUnitTime.years:
        return { min: 1, max: 3 };
      case SubscriptionUnitTime.days:
        return { min: 1, max: 365 };
      default:
        return { min: 1, max: 36 };
    }
  }

  /**
   * Kiểm tra khách hàng có hạn mức AI không
   * @returns true nếu có, false nếu không
   */
  get checkCustomerHasAIQuota() {
    return this.hasAiFeature &&
      this.customerDetail.aiQuota?.aiQuotaType !== AiQuotaType.NoUse &&
      this.selectedSubscriptionPlan?.aiQuota &&
      this.selectedSubscriptionPlan.aiQuota.type !== AiQuotaType.NoUse;
  }

  get isAiQuotaUnlimited() {
    return (this.customerDetail?.aiQuota?.aiQuotaType == AiQuotaType.Unlimited) ||
           (this.selectedSubscriptionPlan?.aiQuota?.type == AiQuotaType.Unlimited);
  }

  async fetchSubscriptionPlans() {
    try {
      this.isLoading = true;
      this.subscriptionPlans = await subscriptionPlanService.getPlans();
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isLoading = false;
    }
  }

  get subscriptionPlanOptions() {
    const options: any[] = this.subscriptionPlans.map(it => ({
      value: it.id,
      text: it.name + " - " + this.formatCurrencyAmount(it.price) + " VND",
    }));
    options.unshift({ text: this.$t("chooseSubscription").toString(), value: null, disabled: true });
    return options;
  }


  get selectedSubscriptionPlan() {
    return this.subscriptionPlans.find(it => it.id === this.customerSubscription?.subscriptionPlanId);
  }


  get startTimeMoment(): Moment {
    return moment.utc(this.startTime, "YYYY-MM-DD", true);
  }


  // Ngày hết hạn hiện tại
  get currentExpDateStr(): string {
    return moment(this.customerSubscription.endTime).format("DD/MM/YYYY");
  }


  //numberOfDaysUsage: hiện thị ngày khi được cộng số tháng nhập vào
  get expDateStr(): string {
    let newStartTimeMoment = moment(this.customerSubscription.endTime);
    if (newStartTimeMoment.isBefore()) {
      newStartTimeMoment = moment();
    }
    return newStartTimeMoment
      .add(this.selectedSubscriptionPlan.numberOfDaysUsage, this.selectedSubscriptionPlan.unitTime)
      .format("DD/MM/YYYY");
  }


  // Hiển thị giá tiền chưa thuế
  get priceStr(): string {
    return this.formatCurrencyAmount(this.selectedSubscriptionPlan.price);
  }


  // Hiển thị thuế VAT
  get taxAmountStr(): string {
    return this.formatCurrencyAmount(new BigNumber(this.selectedSubscriptionPlan.price).multipliedBy(0.1).decimalPlaces(0).toNumber());
  }


  // Hiển thị giá tiền đã bao gồm thuế
  get dueAmountStr(): string {
    return this.formatCurrencyAmount(new BigNumber(this.selectedSubscriptionPlan.price).multipliedBy(1.1).decimalPlaces(0).toNumber());
  }


  onClickCancel() {
    this.$bvModal.hide("setting-subscription-modal");
  }


  async submitForm() {
    try {
      this.isSubmitting = true;
      if (this.settingType === SettingType.Quota) {
        const isPool = this.selectedSubscriptionPlan?.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL;
        const payload = {
          customerSubscriptionId: this.customerSubscription.id,
          numberOfConcurrentMeetings: isPool ? null : +this.numberOfConcurrentMeetings,
          meetingConcurrentParticipantsLimit: isPool ? +this.maxParticipantPool : +this.meetingConcurrentParticipantsLimit,
          maxParticipantPool: isPool ? +this.maxParticipantPool : null
        };
        await customerService.settingsSubscription(payload);
      } else if (this.settingType === SettingType.Storage) {
        // API PurchaseAdditionalStorage yêu cầu truyền lên dung lượng mua thêm.
        const payload = {
          customerSubscriptionId: this.customerSubscription.id,
          storageSize: util.gbToBytes(Number(this.extraStorageToBuy))
        };
        await customerService.purchaseAdditionalStorage(payload);
      } else if (this.settingType === SettingType.AI) {
        // API PurchaseAdditionalAiMinutes yêu cầu truyền lên thời lượng AI mua thêm.
        const payload = {
          customerSubscriptionId: this.customerSubscription.id,
          aiMinutes: Number(this.aiMinutesToBuy)
        };
        await customerService.purchaseAdditionalAiMinutes(payload);
      }
      this.__submitted();
      this.$bvModal.hide("setting-subscription-modal");
      this.toastSuccessDelay(this.$t("settingServiceSuccess").toString());
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isSubmitting = false;
    }
  }


  get isConcurrentMeetingStorageType(): boolean {
    return this.selectedSubscriptionPlan?.storage?.type === StorageType.ConcurrentMeeting;
  }

  get totalStorageAfterPurchase(): number {
    const baseStorage = Number(this.storageSubscription);
    const currentExtra = Number(this.currentExtraStorage);
    const extraToBuy = Number(this.extraStorageToBuy);
    if (this.isConcurrentMeetingStorageType) {
      return baseStorage * Number(this.numberOfConcurrentMeetings) + currentExtra + extraToBuy;
    }
    return baseStorage + currentExtra + extraToBuy;
  }

  /**
   * Phân loại gói cước, nếu null => cố định
   */
  get typeSubscription() {
    const type = this.selectedSubscriptionPlan?.storage?.type ?? null;
    const label = getStorageTypeLabel(type);
    return label;
  }
  /**
  * Dung lượng gói cước 
  */


  get storageSubscription() {
    const type = util.bytesToGB(this.selectedSubscriptionPlan?.storage?.maxSize, true, 2);
    // console.log(JSON.stringify(this.selectedSubscriptionPlan));
    return type;
  }

  get currentExtraStorage() {
    return this.customerDetail?.purchasedStorageSize ? util.bytesToGB(this.customerDetail.purchasedStorageSize, true, 0) : 0;
  }

  get currentExtraAiMinutes() {
    return this.customerDetail?.aiQuota?.purchasedMinutes ?? 0;
  }


  /**
   * Dung lượng Hạn mức AI 
   */


  get aiQuotaSubscription() {
    const numberAIQuota = this.selectedSubscriptionPlan?.aiQuota?.minutes || 0;
    // console.log(JSON.stringify(this.selectedSubscriptionPlan));
    return numberAIQuota;
  }

  get aiQuotaTypeLabel() {
    if (!this.selectedSubscriptionPlan || !this.selectedSubscriptionPlan.aiQuota) {
      return "";
    }
    const type = this.selectedSubscriptionPlan.aiQuota.type;
    switch (type) {
      case AiQuotaType.Fixed:
        return this.$t("aiQuotaType_Fixed").toString();
      case AiQuotaType.NoReset:
        return this.$t("aiQuotaType_NoReset").toString();
      case AiQuotaType.Unlimited:
        return this.$t("aiQuotaType_Unlimited").toString();
      default:
        return "";
    }
  }
}
</script>
